import { nativeNumericStrategy } from "./chunk.RB2JR2ND.js";

// src/utilities/defaultSettings/base.ts
var defaultSettings = {
  delimiter: {
    SynSelect: " "
  },
  numericStrategy: {
    SynInput: nativeNumericStrategy
  },
  size: {
    SynAccordion: "medium",
    SynButton: "medium",
    SynCheckbox: "medium",
    SynCombobox: "medium",
    SynDetails: "medium",
    SynFile: "medium",
    SynIconButton: "inherit",
    SynInput: "medium",
    SynRadio: "medium",
    SynRadioButton: "medium",
    SynRadioGroup: "medium",
    SynRange: "medium",
    SynSelect: "medium",
    SynSwitch: "medium",
    SynTag: "medium",
    SynTextarea: "medium"
  },
  variant: {
    SynAlert: "primary",
    SynBadge: "primary",
    SynButton: "outline",
    SynSideNav: "default",
    SynValidate: "native"
  }
};
var INITIAL_DEFAULT_SETTINGS = {
  delimiter: {
    SynSelect: " "
  },
  numericStrategy: {
    SynInput: nativeNumericStrategy
  },
  size: {
    SynAccordion: "medium",
    SynButton: "medium",
    SynCheckbox: "medium",
    SynCombobox: "medium",
    SynDetails: "medium",
    SynFile: "medium",
    SynIconButton: "inherit",
    SynInput: "medium",
    SynRadio: "medium",
    SynRadioButton: "medium",
    SynRadioGroup: "medium",
    SynRange: "medium",
    SynSelect: "medium",
    SynSwitch: "medium",
    SynTag: "medium",
    SynTextarea: "medium"
  },
  variant: {
    SynAlert: "primary",
    SynBadge: "primary",
    SynButton: "outline",
    SynSideNav: "default",
    SynValidate: "native"
  }
};
export { defaultSettings, INITIAL_DEFAULT_SETTINGS };
